import React from "react";
import PropTypes from "prop-types";
import styles from "./ResourceTypeIcon.module.css";
import playIcon from "./Play_Icon.svg";
import viewIcon from "./View_Icon.svg";

export function ResourceTypeIcon({ onClick, format }) {
  const getFileAttributes = (format) => {
    let iconSrc;

    switch (format) {
      case 1:
        iconSrc = viewIcon;
        break;
      case 2:
      case 3:
        iconSrc = playIcon;
        break;
      case 4:
      case 5:
      case 6:
      case 7:
      case 8:
        iconSrc = viewIcon;
        break;
      default:
        iconSrc = viewIcon;
        break;
    }

    return iconSrc;
  };

  const iconSrc = getFileAttributes(format);

  return (
    <div>
      <img src={iconSrc} alt="icon" onClick={onClick} className={styles.icon} />
    </div>
  );
}

ResourceTypeIcon.propTypes = {
  onClick: PropTypes.func,
  format: PropTypes.number,
};
export default ResourceTypeIcon;
